import { useEffect, useState } from 'react';

import { mapBridge } from './mapBridge';

export function PitchControl() {
  const [pitch, setPitch] = useState(0);

  useEffect(() => mapBridge.subscribePitch(setPitch), []);

  const topDown = mapBridge.isTopDown(pitch);
  const label = topDown ? '3D' : '2D';

  return (
    <button
      type="button"
      onClick={() => mapBridge.togglePitchView()}
      className="flex h-9 w-9 items-center justify-center rounded-lg bg-bg-panel/90 text-xs font-semibold tracking-wide text-slate-100 shadow ring-1 ring-bg-border backdrop-blur hover:bg-white/5 active:bg-white/10"
      aria-label={topDown ? 'Switch to 3D side view' : 'Switch to top-down 2D view'}
      title={topDown ? 'Tilt to 3D view' : 'Return to top-down view'}
    >
      {label}
    </button>
  );
}
